import { BreadCrumbs } from '@app/components/BreadCrumbs';
import { Layout } from '@app/components/Layout';
import { useAuth } from '@app/hooks/useAuth';
import { Stack } from '@mui/material';
import { Actions } from './Actions';
import { Table } from './Table';

export function PointsHistory() {
  const { isAdmin } = useAuth();

  return (
    <Layout>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <BreadCrumbs
          links={[
            {
              label: 'Dashboard',
              link: '/',
            },
            {
              label: 'Points History',
              link: '/points/history',
            },
          ]}
        />
        {isAdmin && <Actions />}
      </Stack>
      <Table />
    </Layout>
  );
}
